import styled from "styled-components"
import media from "styled-media-query"

export const FilterHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  height: 100px;
`

export const Content = styled.div`
  max-width: 1180px;
  width: 1180px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 15px;

  ${media.lessThan("1179px")`
    justify-content: space-around;
  `}
`

export const Tag = styled.div`
  width: auto;
  height: 40px;

  background: #00D07E;
  border-radius: 2px;
  font-size: 24px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  padding: 0 15px;
  justify-content: space-between;
  padding-right: 10px;

  ${media.lessThan("960px")`
     height: 40px;
     font-size: 20px;
  `}

  ${media.lessThan("768px")`
     height: 40px;
     font-size: 18px;
  `}

  ${media.lessThan("500px")`
     height: 40px;
     font-size: 16px;
  `}
`

export const Close = styled.a`
  margin-left: 10px;
  svg {
    width: 27px;
    height: 27px;
    color: #ffffff;

    ${media.lessThan("960px")`
      width: 24px; 
      height: 24px;
    `}

    ${media.lessThan("768px")`
      width: 22px; 
      height: 22px;
    `}
  }
`

export const Posts = styled.div`
  display: flex;
  align-items: center;
`

export const Icon = styled.div`
  margin-right: 2px;
  svg {
    width: 27px;
    fill: #00d07e;
  }
`

export const NumberPosts = styled.span`
  font-size: 16px;
  line-height: 27px;
  color: var(--whiteToBlack);
`
